let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("fliVL"), load("1Yl0r")]).then(() => parcelRequire('9toZG'));